module.exports = __webpack_public_path__ + "static/media/logo.ca1c92d7.png";